// extracted by mini-css-extract-plugin
module.exports = {"section":"PlayerStatsModule_section__v_YSO","edit":"PlayerStatsModule_edit__y0dOS","stats":"PlayerStatsModule_stats__3xAZN"};